import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 16);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer shrink-0">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-600 text-background-50 text-lg">
            <i className="ri-plant-fill"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">漫蛙</span>
            <span className="text-[10px] md:text-xs text-foreground-600 tracking-wide">客户端下载中心</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1 lg:gap-2">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:text-primary-700 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#download"
            className="hidden sm:inline-flex items-center gap-2 px-4 md:px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line"></i>
            立即下载
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2.5 text-sm text-foreground-700 rounded-md bg-background-100 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 w-full px-4 py-3 rounded-md bg-primary-600 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-download-line"></i>
            立即下载客户端
          </a>
        </div>
      )}
    </header>
  );
}